<irembogov-currency-format-input
  [formControl]="formControl"
  ngDefaultControl
  [id]="field.key"
  [placeholder]="props['placeholder']">
</irembogov-currency-format-input>
